// src/pages/FAQ.js
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import PageIntro from "../components/PageIntro";

const faqSections = [
  {
    title: "Allgemeine Fragen zur Erdwärme",
    items: [
      {
        q: "Eignet sich mein Grundstück grundsätzlich für Erdwärme?",
        a: (
          <>
            Ob ein Grundstück für Erdwärme geeignet ist, hängt unter anderem
            von der verfügbaren Fläche, den geologischen
            Untergrundverhältnissen, dem Grundwasser sowie von rechtlichen
            Rahmenbedingungen ab. Der GeoReport liefert hierzu eine
            standortbezogene Ersteinschätzung auf Basis öffentlich verfügbarer
            Geodaten.
          </>
        ),
        schemaText:
          "Ob ein Grundstück für Erdwärme geeignet ist, hängt unter anderem von der verfügbaren Fläche, den geologischen Untergrundverhältnissen, dem Grundwasser sowie von rechtlichen Rahmenbedingungen ab. Der GeoReport liefert hierzu eine standortbezogene Ersteinschätzung auf Basis öffentlich verfügbarer Geodaten.",
      },
      {
        q: "Was ist der Unterschied zwischen Erdkollektor und Erdsonde?",
        a: (
          <>
            Erdkollektoren nutzen oberflächennahe Erdwärme in geringer Tiefe und
            benötigen dafür ausreichend Grundstücksfläche. Erdsonden werden
            vertikal in größere Tiefen gebohrt, liefern stabilere Temperaturen
            und benötigen weniger Fläche, sind jedoch in der Regel
            genehmigungspflichtig.
          </>
        ),
        schemaText:
          "Erdkollektoren nutzen oberflächennahe Erdwärme in geringer Tiefe und benötigen dafür ausreichend Grundstücksfläche. Erdsonden werden vertikal in größere Tiefen gebohrt, liefern stabilere Temperaturen und benötigen weniger Fläche, sind jedoch in der Regel genehmigungspflichtig.",
      },
      {
        q: "Wie zuverlässig sind Aussagen zur Wirtschaftlichkeit von Erdwärme?",
        a: (
          <>
            Aussagen zur Wirtschaftlichkeit sind immer standort- und
            gebäudespezifisch. Pauschale Aussagen sind daher nur begrenzt
            belastbar. Der GeoReport arbeitet mit standortbezogenen Kennwerten,
            Bandbreiten und transparenten Annahmen, ersetzt jedoch keine
            detaillierte Fachplanung.
          </>
        ),
        schemaText:
          "Aussagen zur Wirtschaftlichkeit sind immer standort- und gebäudespezifisch. Pauschale Aussagen sind daher nur begrenzt belastbar. Der GeoReport arbeitet mit standortbezogenen Kennwerten, Bandbreiten und transparenten Annahmen, ersetzt jedoch keine detaillierte Fachplanung.",
      },
      {
        q: "Ist Erdwärme im Neubau und im Bestand sinnvoll?",
        a: (
          <>
            Grundsätzlich kann flache Geothermie sowohl im Neubau als auch bei
            Bestandsgebäuden sinnvoll sein. Im Neubau sind die Voraussetzungen
            oft besonders günstig, weil niedrige Vorlauftemperaturen und eine
            gute Gebäudeeffizienz bereits eingeplant werden können. Im Bestand
            hängt die Eignung stärker vom Wärmebedarf, dem Heizsystem und den
            verfügbaren Flächen ab.
          </>
        ),
        schemaText:
          "Grundsätzlich kann flache Geothermie sowohl im Neubau als auch bei Bestandsgebäuden sinnvoll sein. Im Neubau sind die Voraussetzungen oft besonders günstig, weil niedrige Vorlauftemperaturen und eine gute Gebäudeeffizienz bereits eingeplant werden können. Im Bestand hängt die Eignung stärker vom Wärmebedarf, dem Heizsystem und den verfügbaren Flächen ab.",
      },
    ],
  },
  {
    title: "Fragen zum GeoReport",
    items: [
      {
        q: "Was genau ist der GeoReport?",
        a: (
          <>
            Der GeoReport ist eine automatisierte Ersteinschätzung zur Eignung
            Ihres Grundstücks für flache Geothermie. Er kombiniert öffentlich
            verfügbare Geodaten mit vereinfachten Berechnungsmodellen und
            liefert eine nachvollziehbare Einordnung zu Untergrund, Systemwahl,
            Kosten und Fördermöglichkeiten – individuell für die eingegebene
            Adresse.
          </>
        ),
        schemaText:
          "Der GeoReport ist eine automatisierte Ersteinschätzung zur Eignung Ihres Grundstücks für flache Geothermie. Er kombiniert öffentlich verfügbare Geodaten mit vereinfachten Berechnungsmodellen und liefert eine nachvollziehbare Einordnung zu Untergrund, Systemwahl, Kosten und Fördermöglichkeiten – individuell für die eingegebene Adresse.",
      },
      {
        q: "Ersetzt der GeoReport eine Fachplanung oder ein Baugrundgutachten?",
        a: (
          <>
            Nein. Der GeoReport ersetzt weder eine detaillierte Fachplanung noch
            ein Baugrund- oder Genehmigungsgutachten. Er dient als fundierte
            Entscheidungs- und Vergleichsgrundlage in einer frühen
            Projektphase.
          </>
        ),
        schemaText:
          "Nein. Der GeoReport ersetzt weder eine detaillierte Fachplanung noch ein Baugrund- oder Genehmigungsgutachten. Er dient als fundierte Entscheidungs- und Vergleichsgrundlage in einer frühen Projektphase.",
      },
      {
        q: "Ist das eine persönliche Beratung?",
        a: (
          <>
            Nein. Der GeoReport ist bewusst kein individuelles Beratungs- oder
            Consulting-Angebot. Alle Auswertungen erfolgen automatisiert,
            datenbasiert und nach einheitlichen Annahmen – ohne persönliche
            Gespräche oder projektspezifische Einzelberatung.
          </>
        ),
        schemaText:
          "Nein. Der GeoReport ist bewusst kein individuelles Beratungs- oder Consulting-Angebot. Alle Auswertungen erfolgen automatisiert, datenbasiert und nach einheitlichen Annahmen – ohne persönliche Gespräche oder projektspezifische Einzelberatung.",
      },
      {
        q: "Für wen ist der GeoReport besonders sinnvoll?",
        a: (
          <>
            Der GeoReport richtet sich insbesondere an private Bauherren,
            Sanierer, Eigentümer, Energieberater und Planer, die vor einer
            größeren Investition eine schnelle und standortbezogene
            Ersteinschätzung zur Nutzung von Erdwärme benötigen.
          </>
        ),
        schemaText:
          "Der GeoReport richtet sich insbesondere an private Bauherren, Sanierer, Eigentümer, Energieberater und Planer, die vor einer größeren Investition eine schnelle und standortbezogene Ersteinschätzung zur Nutzung von Erdwärme benötigen.",
      },
      {
        q: "Welche Angaben brauche ich für den GeoReport?",
        a: (
          <>
            Für die Erstellung werden insbesondere Angaben zur Adresse, zum
            Gebäude, zur Wohnfläche, zum Heizsystem und – soweit bekannt – zu
            einzelnen Standortparametern benötigt. Einige Werte können
            automatisiert aus standortbezogenen Datenquellen ergänzt werden,
            andere dienen der besseren Einordnung Ihres konkreten Falls.
          </>
        ),
        schemaText:
          "Für die Erstellung werden insbesondere Angaben zur Adresse, zum Gebäude, zur Wohnfläche, zum Heizsystem und – soweit bekannt – zu einzelnen Standortparametern benötigt. Einige Werte können automatisiert aus standortbezogenen Datenquellen ergänzt werden, andere dienen der besseren Einordnung Ihres konkreten Falls.",
      },
      {
        q: "Wie genau sind die Ergebnisse des GeoReports?",
        a: (
          <>
            Der GeoReport liefert eine fundierte Ersteinschätzung auf Basis
            öffentlich verfügbarer Daten und vereinfachter Modelle. Die
            Ergebnisse sind deutlich aussagekräftiger als rein pauschale
            Vergleiche, ersetzen aber keine standortspezifische Fachplanung,
            keine Bohranzeige und kein Baugrundgutachten.
          </>
        ),
        schemaText:
          "Der GeoReport liefert eine fundierte Ersteinschätzung auf Basis öffentlich verfügbarer Daten und vereinfachter Modelle. Die Ergebnisse sind deutlich aussagekräftiger als rein pauschale Vergleiche, ersetzen aber keine standortspezifische Fachplanung, keine Bohranzeige und kein Baugrundgutachten.",
      },
      {
        q: "Prüft der GeoReport, ob Erdwärme an meinem Standort genehmigungsfähig ist?",
        a: (
          <>
            Nein. Der GeoReport führt{" "}
            <b>keine vollständige rechtliche oder behördliche Prüfung</b> durch.
            Er liefert eine technisch-fachliche Ersteinschätzung auf Basis
            öffentlich verfügbarer Daten und typischer Auslegungsrichtlinien
            wie der VDI 4640.
            <br />
            <br />
            Lokale Einschränkungen wie Wasserschutzgebiete, bergrechtliche
            Belange oder individuelle Auflagen können nicht vollständig
            abgebildet werden. Verbindliche Auskünfte erteilen die zuständigen
            Landesbehörden. Eine bundesweite Übersicht bietet das
            Informationssystem <b>GeotIS</b> des LIAG unter{" "}
            <a
              href="https://www.geotis.de/homepage/GeotIS-Startpage?loc=de"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              www.geotis.de
            </a>
            .
          </>
        ),
        schemaText:
          "Nein. Der GeoReport führt keine vollständige rechtliche oder behördliche Prüfung durch. Er liefert eine technisch-fachliche Ersteinschätzung auf Basis öffentlich verfügbarer Daten und typischer Auslegungsrichtlinien wie der VDI 4640. Lokale Einschränkungen wie Wasserschutzgebiete, bergrechtliche Belange oder individuelle Auflagen können nicht vollständig abgebildet werden. Verbindliche Auskünfte erteilen die zuständigen Landesbehörden. Eine bundesweite Übersicht bietet das Informationssystem GeotIS des LIAG.",
      },
      {
        q: "Kann ich mit dem GeoReport Angebote vergleichen?",
        a: (
          <>
            Ja. Der GeoReport stellt zentrale Annahmen, Kennzahlen und
            Bandbreiten transparent dar. Dadurch lassen sich Angebote besser
            einordnen und gezielt hinterfragen, insbesondere im Hinblick auf
            Dimensionierung, Untergrundannahmen und Wirtschaftlichkeit.
          </>
        ),
        schemaText:
          "Ja. Der GeoReport stellt zentrale Annahmen, Kennzahlen und Bandbreiten transparent dar. Dadurch lassen sich Angebote besser einordnen und gezielt hinterfragen, insbesondere im Hinblick auf Dimensionierung, Untergrundannahmen und Wirtschaftlichkeit.",
      },
      {
        q: "Wie lange dauert die Erstellung des Reports?",
        a: (
          <>
            Die Erstellung erfolgt automatisiert und dauert in der Regel nur
            wenige Minuten nach vollständiger Eingabe der erforderlichen Daten.
            Der Report steht anschließend direkt als PDF zur Verfügung.
          </>
        ),
        schemaText:
          "Die Erstellung erfolgt automatisiert und dauert in der Regel nur wenige Minuten nach vollständiger Eingabe der erforderlichen Daten. Der Report steht anschließend direkt als PDF zur Verfügung.",
      },
      {
        q: "Was kostet der GeoReport?",
        a: (
          <>
            Den aktuellen Preis finden Sie direkt auf der Eingabeseite des
            GeoReports. Dort sehen Sie vor dem Kauf transparent, welche
            Leistungen enthalten sind.
          </>
        ),
        schemaText:
          "Den aktuellen Preis finden Sie direkt auf der Eingabeseite des GeoReports. Dort sehen Sie vor dem Kauf transparent, welche Leistungen enthalten sind.",
      },
    ],
  },
];

export default function FAQ() {
  useEffect(() => {
    document.title =
      "FAQ zu Erdwärme, Erdsonden und GeoReport | Erdwärme-Experten";

    let meta = document.querySelector("meta[name='description']");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.setAttribute(
      "content",
      "Antworten auf häufige Fragen zu Erdwärme, Geothermie, Erdkollektoren, Erdsonden und zum GeoReport als erster standortbezogener Einschätzung."
    );

    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = "https://www.erdwaerme-experten.de/faq";
  }, []);

  useEffect(() => {
    const allFaqItems = faqSections.flatMap((section) => section.items);

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: allFaqItems.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.schemaText,
        },
      })),
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(faqSchema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-slate-50 to-[#f6f3f2] pb-20 pt-14 sm:pt-20">
      <PageIntro
        eyebrow="Wissen & Orientierung"
        title="Häufige Fragen zu Erdwärme und zum GeoReport"
        description={
          <p>
            Hier finden Sie verständliche Antworten zu flacher Geothermie,
            Erdkollektoren, Erdsonden und unserer standortbezogenen
            Ersteinschätzung. Technische Grundlagen haben wir außerdem auf der{" "}
            <Link
              to="/flache-geothermie"
              className="font-semibold text-red-700 underline decoration-red-200 underline-offset-4 hover:text-red-800"
            >
              Übersichtsseite zur flachen Geothermie
            </Link>{" "}
            zusammengefasst.
          </p>
        }
        badges={["Technik verständlich erklärt", "GeoReport transparent", "Planung realistisch einordnen"]}
        className="mb-10"
      />

      <main className="mx-auto max-w-6xl px-4 sm:px-6">
        <nav
          aria-label="FAQ-Bereiche"
          className="mb-8 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:flex sm:items-center sm:justify-between sm:px-6"
        >
          <p className="text-sm font-semibold text-slate-700">
            Direkt zum Themenbereich
          </p>
          <div className="mt-3 flex flex-wrap gap-2 sm:mt-0">
            <a
              href="#grundlagen"
              className="rounded-full border border-slate-200 bg-slate-50 px-4 py-2 text-sm font-medium text-slate-700 transition hover:border-red-200 hover:bg-red-50 hover:text-red-700"
            >
              Grundlagen
            </a>
            <a
              href="#georeport"
              className="rounded-full border border-slate-200 bg-slate-50 px-4 py-2 text-sm font-medium text-slate-700 transition hover:border-red-200 hover:bg-red-50 hover:text-red-700"
            >
              GeoReport
            </a>
            <a
              href="#beispiel-report"
              className="rounded-full border border-slate-200 bg-slate-50 px-4 py-2 text-sm font-medium text-slate-700 transition hover:border-red-200 hover:bg-red-50 hover:text-red-700"
            >
              Beispiel ansehen
            </a>
          </div>
        </nav>

        <div className="space-y-8">
          {faqSections.map((section, sectionIndex) => {
            const sectionId = sectionIndex === 0 ? "grundlagen" : "georeport";

            return (
              <section
                key={section.title}
                id={sectionId}
                className="scroll-mt-24 rounded-3xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8 lg:p-10"
              >
                <div className="mb-7 flex items-start gap-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-red-50 text-sm font-bold text-red-700">
                    {String(sectionIndex + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <p className="text-xs font-bold uppercase tracking-[0.16em] text-red-600">
                      FAQ-Bereich
                    </p>
                    <h2 className="mt-1 text-2xl font-bold tracking-tight text-slate-950 sm:text-3xl">
                      {section.title}
                    </h2>
                  </div>
                </div>

                <div className="space-y-3">
                  {section.items.map((item) => (
                    <FAQItem key={item.q} q={item.q} a={item.a} />
                  ))}
                </div>
              </section>
            );
          })}
        </div>

        <section
          id="beispiel-report"
          className="mt-10 scroll-mt-24 rounded-3xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8 lg:p-10"
        >
          <div className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
            <div className="max-w-3xl">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-red-600">
                Einblick in das Ergebnis
              </p>
              <h2 className="mt-2 text-2xl font-bold tracking-tight text-slate-950 sm:text-3xl">
                Wie sieht ein GeoReport aus?
              </h2>
              <p className="mt-3 leading-7 text-slate-600">
                Der anonymisierte Beispiel-Report zeigt Aufbau, Detailtiefe und
                Art der technischen und wirtschaftlichen Auswertungen.
              </p>
            </div>

            <a
              href="/example-report.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex shrink-0 items-center justify-center rounded-xl border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-slate-800 shadow-sm transition hover:border-red-200 hover:bg-red-50 hover:text-red-700"
            >
              PDF separat öffnen
            </a>
          </div>

          <div className="mt-7 overflow-hidden rounded-2xl border border-slate-200 bg-slate-100 shadow-inner">
            <iframe
              src="/example-report.pdf"
              title="Beispiel GeoReport"
              className="h-[520px] w-full bg-white sm:h-[680px]"
              loading="lazy"
            />
          </div>

          <p className="mt-4 text-sm leading-6 text-slate-500">
            Der dargestellte Report ist ein Beispiel. Inhalte und Ergebnisse
            variieren je nach Standort und Eingabedaten.
          </p>
        </section>

        <section className="mt-10 overflow-hidden rounded-3xl border border-red-100 bg-gradient-to-br from-white to-red-50 p-6 shadow-sm sm:p-8 lg:p-10">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-3xl">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-red-600">
                Nächster Schritt
              </p>
              <h2 className="mt-2 text-2xl font-bold tracking-tight text-slate-950 sm:text-3xl">
                Ihr Grundstück standortbezogen prüfen
              </h2>
              <p className="mt-3 leading-7 text-slate-600">
                Erstellen Sie in wenigen Minuten eine datenbasierte
                Ersteinschätzung zu Untergrund, Systemwahl, Dimensionierung,
                Kosten und Förderung.
              </p>
            </div>

            <div className="shrink-0">
              <Link
                to="/report"
                className="inline-flex w-full items-center justify-center rounded-xl bg-red-600 px-7 py-3.5 font-semibold text-white shadow-sm transition hover:bg-red-700 sm:w-auto"
              >
                GeoReport erstellen
              </Link>
              <p className="mt-2 text-center text-xs text-slate-500">
                Aktuell kostenlos in der Beta
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

function FAQItem({ q, a }) {
  return (
    <details className="group rounded-2xl border border-slate-200 bg-white shadow-sm transition open:border-red-200 open:shadow-md">
      <summary
        className="flex cursor-pointer items-center justify-between gap-5 px-5 py-5 text-left sm:px-6"
        style={{ listStyle: "none" }}
      >
        <span className="text-base font-semibold leading-6 text-slate-900 sm:text-lg">
          {q}
        </span>
        <span
          aria-hidden="true"
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-100 text-xl font-light text-slate-600 transition group-open:rotate-45 group-open:bg-red-50 group-open:text-red-700"
        >
          +
        </span>
      </summary>
      <div className="border-t border-slate-100 px-5 py-5 leading-7 text-slate-600 sm:px-6 [&_a]:font-medium [&_a]:text-red-700 [&_a]:underline [&_a]:underline-offset-4">
        {a}
      </div>
    </details>
  );
}
